import styles from "./styles.module.scss";
import Section from "../../components/Section";

import img1 from "../../images/1.png";
import fresh_coffee from "../../images/fresh_coffee.png";
import adobe_icon from "../../graphics/adobe_icon.svg";
import zoo_icon from "../../graphics/zoo_icon.svg";
import estate_icon from "../../graphics/estate_icon.svg";

const Logos = () => {
  return (
    <>
      <Section color="#1D1D1D">
        <div className={styles.container}>
          <div className={styles.title}>
            <div>
              <img src={img1} alt="1" />
            </div>
            <h1>ЛОГОТИПЫ</h1>
          </div>

          <div className={styles.content}>
            <div className={styles.task}>
              <h4 className={styles.sub_title}>Задача</h4>
              <p className={styles.text}>
                Разработать логотип для местной кофейни, регионального зоопарка
                и элитного агентства недвижимости. Логотипы должны отражать
                уникальность и располагать клиентов.
              </p>
            </div>

            <div>
              <img src={fresh_coffee} alt="fresh coffee" />
            </div>

            <div className={styles.execution}>
              <h4 className={styles.sub_title}>Реализация</h4>
              <div className={styles.logo_text}>
                <div>
                  <img src={adobe_icon} alt="adobe" />
                </div>
                Adobe Illustrator
              </div>
              <p className={styles.text}>
                Логотипы были разработаны с внедрением символизирующих
                абстракций.
              </p>
            </div>
          </div>
        </div>
      </Section>
      <div className={styles.display}>
        <div className={styles.zoo}>
          <img src={zoo_icon} alt="Уфа зоопарк" />
        </div>
        <div className={styles.estate}>
          <img src={estate_icon} alt="Premium estate" />
        </div>
      </div>
    </>
  );
};

export default Logos;
